module.exports = __webpack_public_path__ + "img/3.bb77afdf.png";